import React, { useContext } from "react"
import { Route, Redirect } from "react-router-dom"
import { AuthContext } from "../../contexts/AuthContext"

export default function ProtectedRoute({ component: Component, ...rest }) {
    const { user, loading } = useContext(AuthContext)

    return (
        <Route
            {...rest}
            render={props => {
                if (loading) return null // session restore (refresh) in flight
                return user ? <Component {...props} /> : <Redirect to="/" />
            }}
        >
        </Route>
    )
}